import React from 'react';
import styles from './privacy.module.scss';
export default (props) => {
    const { title, content, onConfirm } = props;
    return React.createElement("div", { className: styles['privacy-panel'], onClick: (e) => {
            e.stopPropagation();
        } },
        React.createElement("div", { className: styles['title'] }, title),
        React.createElement("div", { className: styles['divider'] }),
        React.createElement("div", { className: styles['content'] }, content),
        React.createElement("div", { className: styles['divider'] }),
        React.createElement("div", { className: styles['confirm-btn'], onClick: () => {
                onConfirm && onConfirm();
            } }, "\u540C\u610F\u5E76\u7EE7\u7EED"));
};
